import styled from 'styled-components';
import { brand } from 'styles/Colors';

export const EditModeWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 3e-5) 100%);
  width: 100%;
`;

export const EditModeOverlay = styled.div`
  width: 100%;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 6e-5) 100%);
  // background: linear-gradient(180deg, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 3e-5) 100%);
  height: 50px;
  opacity: 0.8;
  backdrop-filter: blur(60px);
`;

export const EditMode = styled.div`
  background-color: ${brand};
  padding: 5px 8px;
  border-radius: 32px;
  color: #ffffff;
  width: fit-content;
  font-size: 11px;
  line-height: 10px;
  font-weight: 700;
  position: absolute;
  top: 12px;
  right: 8px;

  svg {
    margin-right: 4px;
  }
`;
